var path = 'api/Portal/Lookup/'

const YesNoList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' }
]

const CountryEnum = {
    UnitedStates: 377,
    Canada: 152,
    Other: 406
}

const StateEnum = {
    Other: 9998,
    Unknown: 9999
}

const UnknownOtherStates = [
    { id: StateEnum.Other, description: 'Other' },
    { id: StateEnum.Unknown, description: 'Unknown' }
]

const RaceEnum = {
    White: 1,
    BlackOrAfricanAmerican: 2,
    AmericanIndianOrAfricanAmerican: 3,
    AsianIndian: 4,
    Chinese: 5,
    Filipino: 6,
    Japanese: 7,
    Korean: 8,
    Vietnamese: 9,
    OtherAsian: 10,
    NativeHawaiian: 11,
    GuamanianOrChamorro: 12,
    Samoan: 13,
    OtherPacificIslander: 14,
    Other: 15,
    Unknown: 16,
    Refused: 17,
    NotObtainable: 18
}

const HispanicOriginEnum = {
    Other: 5
}

const ModuleTypeEnum = {
    Birth: 10,
    Marriage: 20,
    Divorce: 30,
    Death: 40
}

const MessageReasonTypeEnum = {
    ExcessiveCopies: 1
}

function GetUserRoles (http) {
    return http.post(path + 'GetUserRoles')
}

function GetSuffixes (http) {
    return http.post(path + 'GetSuffixes')
}

function GetMessageTypes (http) {
    return http.post(path + 'GetMessageTypes')
}

function GetStates (http) {
    return http.post(path + 'GetStates')
}

function GetStatesByCountry (http, countryId) {
    return http.post(path + 'GetStatesByCountry?countryId=' + countryId)
}

function GetStateAbbrs (http) {
    return http.post(path + 'GetStateAbbrs')
}

function GetCanadianTerritories (http) {
    return http.post(path + 'GetCanadianTerritories')
}

function GetCountries (http) {
    return http.post(path + 'GetCountries')
}

function GetEducationTypes (http) {
    return http.post(path + 'GetEducationTypes')
}

function GetHispanicOriginTypes (http) {
    return http.post(path + 'GetHispanicOriginTypes')
}

function GetWyomingCities (http) {
    return http.post(path + 'GetWyomingCities')
}

function GetCountyClerkCountyFacilities (http) {
    return http.post(path + 'GetCountyClerkCountyFacilities')
}

function GetWyomingCounties (http) {
    return http.post(path + 'GetWyomingCounties')
}

function GetCertificateImageTypes (http) {
    return http.post(path + 'GetCertificateImageTypes')
}

function GetFemaleHispanicOriginTypes (http) {
    return http.post(path + 'GetFemaleHispanicOriginTypes')
}

function GetAgencies (http) {
    return http.post(path + 'GetAgencies')
}

function GetSexList (http) {
    return http.get(path + 'GetSexList')
}

function GetMarriageMaritalStatusList (http) {
    return http.get(path + 'GetMarriageMaritalStatusList')
}

function GetPortalMessageReasons (http, moduleTypeId, certificateId) {
    return http.get(path + 'GetPortalMessageReasons?moduleTypeId=' + moduleTypeId + '&certificateId=' + certificateId)
}

export default {
    CountryEnum: CountryEnum,
    StateEnum: StateEnum,
    UnknownOtherStates: UnknownOtherStates,
    RaceEnum: RaceEnum,
    HispanicOriginEnum: HispanicOriginEnum,
    ModuleTypeEnum: ModuleTypeEnum,
    MessageReasonTypeEnum: MessageReasonTypeEnum,
    GetUserRoles: GetUserRoles,
    GetSuffixes: GetSuffixes,
    GetMessageTypes: GetMessageTypes,
    GetStates: GetStates,
    GetCanadianTerritories: GetCanadianTerritories,
    GetCountries: GetCountries,
    GetEducationTypes: GetEducationTypes,
    GetHispanicOriginTypes: GetHispanicOriginTypes,
    GetFemaleHispanicOriginTypes: GetFemaleHispanicOriginTypes,
    YesNoList: YesNoList,
    GetWyomingCities: GetWyomingCities,
    GetWyomingCounties: GetWyomingCounties,
    GetCountyClerkCountyFacilities: GetCountyClerkCountyFacilities,
    GetCertificateImageTypes: GetCertificateImageTypes,
    GetStateAbbrs: GetStateAbbrs,
    GetAgencies: GetAgencies,
    GetPortalMessageReasons: GetPortalMessageReasons,
    GetStatesByCountry: GetStatesByCountry,
    GetSexList: GetSexList,
    GetMarriageMaritalStatusList: GetMarriageMaritalStatusList
}
